import Api from "./Api";
import store from "../state/store";
import axios from "axios";
export default {
  getCompliance() {
    return Api().get(`/compliances/${store.getters["authfack/currentEntity"].id}`
    );
  },
  getComplianceDetails(id) {
    return Api().get(`/compliance/${id}`);
  },
  createCompliance(params) {
    return Api().post("/compliance", params);
  },
  updateCompliance(params) {
    return Api().post(`/compliance/${params.id}`,
      params.form
    );
  },
  deleteCompliance(id) {
    return Api().delete(`/compliance/${id}`, {
      params: {
        entity_id: store.getters["authfack/currentEntity"].id
      }
    });
  },
  resendCompliance(params) {
    return Api().post("/compliance-resent", params);
  },
  getUserCompliance(params) {
    return Api().get('/get_compliance_user', {
      params: {
        user_id: params.user_id,
        area_id: params.area_id,
        visit_id: params.visit_id,
        entity_id: params.entity_id,
      }
    });
  },
  getUserOnlineCompliance(id) {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    return axios.get(`${process.env.VUE_APP_BASE_URL}/api/get_online_compliance_user?visitCode=${id}`
    ,{
      headers: headers,
    }
    ).then(response => {
      // console.log('service res', response);
      return Promise.resolve(response)
    })
    .catch(error => {
      // console.log('service err', error.response);
      return Promise.reject(error.response);
    });
  },
  
  createUserCompliance(params) {
    return Api().post('/create_compliance_user', params);
  },

  createUserOnlineCompliance(params) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}/api/create_online_compliance_user`,params)
    .then(response => {
      // console.log('service res', response);
      return Promise.resolve(response)
    })
    .catch(error => {
      // console.log('service err', error.response);
      return Promise.reject(error.response);
    });
  },

  getComplianceUserDetails(params) {
    // console.log('lkk', params);
    return Api().get('/get_compliance_user_details', {
      params: {
        user_id: params.user_id,
        // visit_id: params.visit_id,
        scan_id: params.scan_id,
        entity_id: params.entity_id,
        // date_before: params.date_before,
        // date_after: params.date_after,
      }
    });
  },
  canChangeComplianceFormat(id) {
    return Api().get(`/can_edit_compliance/${id}`);
  },
};
